import { useShiftData } from './useShiftData';
import { useShiftHandlers } from './useShiftHandlers';
import { useShiftSync } from './useShiftSync';

export function useWeeklyShifts() {
  const data = useShiftData();

  const handlers = useShiftHandlers({
    activeTab: data.activeTab,
    startDate: data.startDate,
    tableShifts: data.tableShifts,
    allEmployees: data.allEmployees,
    workAreaOptions: data.workAreaOptions,
    draggableWAList: data.draggableWAList,
    hiddenWorkAreas: data.hiddenWorkAreas,
    activeEmployeeId: data.activeEmployeeId,
    editShiftData: data.editShiftData,
    dragging: data.dragging,
    dropTarget: data.dropTarget,
    showEditShift: data.showEditShift,
    setShowEditShift: data.setShowEditShift,
    setEditShiftData: data.setEditShiftData,
    setShiftData: data.setShiftData,
    setShowAddShift: data.setShowAddShift,
    setDragging: data.setDragging,
    setDropTarget: data.setDropTarget,
    setDraggableWAList: data.setDraggableWAList,
    setShowClearAllModal: data.setShowClearAllModal,
    setShowAutoAssignConfirm: data.setShowAutoAssignConfirm,
    setIsAssigning: data.setIsAssigning,
    setAssignmentLogs: data.setAssignmentLogs,
    addLog: data.addLog,
    fetchTableShifts: data.fetchTableShifts,
  });

  useShiftSync({ fetchTableShifts: data.fetchTableShifts });

  return {
    role: data.role,
    workAreaIds: data.workAreaIds,
    isManager: data.isManager,
    activeTab: data.activeTab,
    setActiveTab: data.setActiveTab,
    tableShifts: data.tableShifts,
    startDate: data.startDate,
    setStartDate: data.setStartDate,
    workAreaOptions: data.workAreaOptions,
    draggableWAList: data.draggableWAList,
    setDraggableWAList: data.setDraggableWAList,
    hiddenWorkAreas: data.hiddenWorkAreas,
    setHiddenWorkAreas: data.setHiddenWorkAreas,
    selectedLocations: data.selectedLocations,
    setSelectedLocations: data.setSelectedLocations,
    ttSelectedWAs: data.ttSelectedWAs,
    setTtSelectedWAs: data.setTtSelectedWAs,
    ttExportOpen: data.ttExportOpen,
    setTtExportOpen: data.setTtExportOpen,
    ttImportOpen: data.ttImportOpen,
    setTtImportOpen: data.setTtImportOpen,
    ttAddOpen: data.ttAddOpen,
    setTtAddOpen: data.setTtAddOpen,
    absenceSelectedWAs: data.absenceSelectedWAs,
    setAbsenceSelectedWAs: data.setAbsenceSelectedWAs,
    absenceAddOpen: data.absenceAddOpen,
    setAbsenceAddOpen: data.setAbsenceAddOpen,
    absenceImportOpen: data.absenceImportOpen,
    setAbsenceImportOpen: data.setAbsenceImportOpen,
    showClearAllModal: data.showClearAllModal,
    setShowClearAllModal: data.setShowClearAllModal,
    showAddShift: data.showAddShift,
    setShowAddShift: data.setShowAddShift,
    shiftData: data.shiftData,
    setShiftData: data.setShiftData,
    showEditShift: data.showEditShift,
    editShiftData: data.editShiftData,
    setEditShiftData: data.setEditShiftData,
    swapRequests: handlers.swapRequests,
    allEmployees: data.allEmployees,
    employeeContracts: data.employeeContracts,
    activeEmployeeId: data.activeEmployeeId,
    setActiveEmployeeId: data.setActiveEmployeeId,
    activeEmployee: data.activeEmployee,
    setActiveEmployee: data.setActiveEmployee,
    displayedTTs: data.displayedTTs,
    ttRangeStart: data.ttRangeStart,
    ttRangeEnd: data.ttRangeEnd,
    ttInitialRange: data.ttInitialRange,
    ttInitialMonth: data.ttInitialMonth,
    ttRangeMode: data.ttRangeMode,
    plannedHoursMap: data.plannedHoursMap,
    dragging: data.dragging,
    dropTarget: data.dropTarget,
    setDropTarget: data.setDropTarget,
    weekAbsences: data.weekAbsences,
    allAbsencesForSidebar: data.allAbsencesForSidebar,
    countsByDate: data.countsByDate,
    absModal: data.absModal,
    setAbsModal: data.setAbsModal,
    weatherData: data.weatherData,
    weatherByLocation: data.weatherByLocation,
    uniqueLocations: data.uniqueLocations,
    weekEvents: data.weekEvents,
    showAutoAssignConfirm: data.showAutoAssignConfirm,
    setShowAutoAssignConfirm: data.setShowAutoAssignConfirm,
    isAssigning: data.isAssigning,
    setIsAssigning: data.setIsAssigning,
    assignmentLogs: data.assignmentLogs,
    showCalendar: data.showCalendar,
    setShowCalendar: data.setShowCalendar,
    calendarBtnRef: data.calendarBtnRef,
    calendarPos: data.calendarPos,
    setCalendarPos: data.setCalendarPos,
    lastShiftDefaults: data.lastShiftDefaults,
    setLastShiftDefaults: data.setLastShiftDefaults,
    fetchTableShifts: data.fetchTableShifts,
    handleShiftClick: handlers.handleShiftClick,
    handleEditClick: handlers.handleEditClick,
    handleLongPressStart: handlers.handleLongPressStart,
    handleToggleAssignment: handlers.handleToggleAssignment,
    handleQuickAdd: handlers.handleQuickAdd,
    closeEditShiftModal: handlers.closeEditShiftModal,
    handleEditShiftSave: handlers.handleEditShiftSave,
    handleEditShiftDelete: handlers.handleEditShiftDelete,
    handleAutoAssignClick: handlers.handleAutoAssignClick,
    executeAutoAssign: handlers.executeAutoAssign,
    handleClearAllClick: handlers.handleClearAllClick,
    handleClearAllConfirm: handlers.handleClearAllConfirm,
    handleWADragEnd: handlers.handleWADragEnd,
    handleShiftDragEnd: handlers.handleShiftDragEnd,
    getWAHours: data.getWAHours,
    getTotalHours: data.getTotalHours,
    handleTTsRangeChange: data.handleTTsRangeChange,
  };
}
